// Color-by-progress: shifts the timer ring color from green → yellow → red
// as time runs out, giving kids a visual sense of urgency without anxiety.

/**
 * @param progress 0 to 1 (1 = full time remaining, 0 = time's up)
 * @returns hex color string
 */
export const getProgressColor = (progress: number): string => {
    const clamped = Math.max(0, Math.min(1, progress));

    if (clamped > 0.5) {
        // Green → Yellow (1.0 → 0.5)
        const t = (1.0 - clamped) / 0.5; // 0 → 1
        return interpolateHex('#22C55E', '#FACC15', t);
    }
    // Yellow → Red (0.5 → 0.0)
    const t = (0.5 - clamped) / 0.5; // 0 → 1
    return interpolateHex('#FACC15', '#EF4444', t);
};

const interpolateHex = (a: string, b: string, t: number): string => {
    const ar = parseInt(a.slice(1, 3), 16);
    const ag = parseInt(a.slice(3, 5), 16);
    const ab = parseInt(a.slice(5, 7), 16);
    const br = parseInt(b.slice(1, 3), 16);
    const bg = parseInt(b.slice(3, 5), 16);
    const bb = parseInt(b.slice(5, 7), 16);
    const r = Math.round(ar + (br - ar) * t);
    const g = Math.round(ag + (bg - ag) * t);
    const bl = Math.round(ab + (bb - ab) * t);
    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${bl.toString(16).padStart(2, '0')}`;
};
